export enum ProductSync {
    Disable = 0,
    Enable = 1,
}